module.exports = __webpack_public_path__ + "img/melo-white.d2bac4ae.svg";